import * as ActionTypes from '../../constants/ActionTypes';

const initialState = {
	application: null,
	loading: false,
	loadingSubmit: false,
	loadingPassportSubmit: false,
	loadingItinerarySubmit: false,
	loadingInsuranceSubmit: false
};

export default function applicationStatusPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_APPLICATION_STATUS_REQUEST:
		case ActionTypes.GET_APPLICATION_STATUS_ERROR:
		case ActionTypes.GET_APPLICATION_STATUS_SUCCESS:
		case ActionTypes.SUBMIT_APPLICATION_STATUS_REQUEST:
		case ActionTypes.SUBMIT_APPLICATION_STATUS_ERROR:
		case ActionTypes.SUBMIT_APPLICATION_STATUS_SUCCESS:
		case ActionTypes.SUBMIT_APPLICATION_PASSPORT_REQUEST:
		case ActionTypes.SUBMIT_APPLICATION_PASSPORT_ERROR:
		case ActionTypes.SUBMIT_APPLICATION_PASSPORT_SUCCESS:
		case ActionTypes.SUBMIT_APPLICATION_ITINERARY_REQUEST:
		case ActionTypes.SUBMIT_APPLICATION_ITINERARY_ERROR:
		case ActionTypes.SUBMIT_APPLICATION_ITINERARY_SUCCESS:
		case ActionTypes.SUBMIT_APPLICATION_INSURANCE_REQUEST:
		case ActionTypes.SUBMIT_APPLICATION_INSURANCE_ERROR:
		case ActionTypes.SUBMIT_APPLICATION_INSURANCE_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_APPLICATION_STATUS_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_APPLICATION_STATUS_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
